<template>
  <div v-if="isRouterAlive">
    <b-container>
      <b-row class="justify-content-md-left about-content-1">
        <b-col cols="10" md="2" lgt="2">
          <span class="about-title">精益生产</span></b-col
        >
        <b-col cols="12" md="10" lgt="10">
          <div class="row">
            <div
              class="col-10"
              style="font-size:20px;font-weight:bold;color:#666666"
            >
              从高标准甄选原材料,到先进的生产检测设备<br />
              到先进的生产工艺流程
            </div>
          </div>
          <div class=" row about-content-info">
            <div class="col-10">
              天鑫人把精益生产理念贯穿于管理的方方面面，让软管像仪表一样精密可靠，是天鑫人始终追求的品质和目标。
            </div>
          </div>
          <b-img
            style="margin-top:40px;"
            src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/production-01.png"
            fluid
            alt="宁波天鑫仪表有限公司"
          ></b-img>

          <div class=" row about-content-info">
            <div class="col-10">
              天鑫人时刻保持一种对行业的敬畏和锐意进取的精神，不断实现材料创新、产品品类的创新，技术的迭代更新和对管理的创新，时时不怠精益生产和追求卓越的脚步。
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-sm-12">
              <b-img
                style="margin-top:40px;"
                src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/production-02.png"
                fluid
                alt="宁波天鑫仪表有限公司"
              ></b-img>
            </div>
            <div class="col-md-4 col-sm-12">
              <b-img
                style="margin-top:40px;"
                src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/production-03.png"
                fluid
                alt="宁波天鑫仪表有限公司"
              ></b-img>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-sm-12">
              <b-img
                style="margin-top:40px;"
                src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/production-04.png"
                fluid
                alt="宁波天鑫仪表有限公司"
              ></b-img>
            </div>
            <div class="col-md-4 col-sm-12">
              <b-img
                style="margin-top:40px;"
                src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/production-05.png"
                fluid
                alt="宁波天鑫仪表有限公司"
              ></b-img>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-sm-12">
              <b-img
                style="margin-top:40px;"
                src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/production-06.png"
                fluid
                alt="宁波天鑫仪表有限公司"
              ></b-img>
            </div>
            <div class="col-md-4 col-sm-12">
              <b-img
                style="margin-top:40px;"
                src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/production-07.png"
                fluid
                alt="宁波天鑫仪表有限公司"
              ></b-img>
            </div>
          </div>
          <div
            class="w-100"
            style=" height:10px;width:100%;margin-top:50px;"
          ></div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Sticky from "sticky-js";
export default {
  props: {
    active: {
      type: Number,
    },
  },
  data() {
    return {
      isRouterAlive: true,

      visible1: false,
    };
  },
  watch: {
    active(v) {
      console.log(v);
    },
  },
  computed: {
    colarrowdown() {
      return this.$store.state.colarrowdown;
    },
    colarrowup() {
      return this.$store.state.colarrowup;
    },
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    getAbout4Page() {
      const _this = this;
      this.$store.dispatch("getAbout4Page").then(({ zh, en }) => {
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);
        let lang = _this.$i18n.locale;
        _this.$i18n.locale = lang;
        _this.reload();
        const sticky = new Sticky(".sticky");
        sticky.update();
        const sticky2 = new Sticky(".sticky2");
        sticky2.update();
      });
    },
  },
  updated() {
  },
  mounted() {
    this.getAbout4Page();
  },
};
</script>
